import { create } from 'zustand';

export type SettingsElementType = {
  key?: string;
  value?: string;
};

export type SettingsListState = {
  isLoaded: boolean;
  data: SettingsElementType[];
};

export type SettingsDataState = {
  settingsList: SettingsListState;
  setSettingsList: (
    updater:
      | SettingsListState
      | ((prevSettingsList: SettingsListState) => SettingsListState)
  ) => void;
};

const useSettingsStore = create<SettingsDataState>((set) => ({
  settingsList: {
    isLoaded: false,
    data: [],
  },
  setSettingsList: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        settingsList: updater(state.settingsList),
      }));
    } else {
      set({ settingsList: updater });
    }
  },
}));

export default useSettingsStore;
